var _rect, _text, _text2, _line, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObianFig3FeedbackLoop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 460",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 460,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Eight days, one tester, and a feature that outlived the bug")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "One external Linux tester's report, and what the loop built into the product on its way to the fix")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 150,
    x2: 1120,
    y2: 150,
    stroke: "#E2E8E4",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fontFamily: "Consolas, monospace",
    fill: "#6B7F74",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 128
  }, "Jun 2"), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 128
  }, "Jun 10"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 150,
    r: 7,
    fill: "#DC2626"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 150,
    r: 7,
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 150,
    r: 7,
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 150,
    r: 7,
    fill: "#1A2F2A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1020,
    cy: 150,
    r: 7,
    fill: "#16A34A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 176,
    width: 168,
    height: 118,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#DC2626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 202,
    fontSize: 11.5,
    fontWeight: 600,
    fill: "#DC2626",
    textAnchor: "middle"
  }, "THE REPORT"), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 224,
    fontSize: 11,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "a screenshot: black area"), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 240,
    fontSize: 11,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "above the web content"), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 256,
    fontSize: 11,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "on Linux X11/XFCE"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 176,
    width: 168,
    height: 118,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 202,
    fontSize: 11.5,
    fontWeight: 600,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "PLAIN-WORDS"), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 218,
    fontSize: 11.5,
    fontWeight: 600,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "DIAGNOSTICS"), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 240,
    fontSize: 11,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "instructions written for"), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 256,
    fontSize: 11,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "the tester, no terminal"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 176,
    width: 168,
    height: 118,
    rx: 10,
    fill: "#F7FAF8",
    stroke: "#7C3AED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 202,
    fontSize: 11.5,
    fontWeight: 600,
    fill: "#7C3AED",
    textAnchor: "middle"
  }, "SHIPPED AS PRODUCT"), /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 224,
    fontSize: 11,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "a Copy diagnostics menu"), /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 240,
    fontSize: 11,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "item, so any user can"), /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 256,
    fontSize: 11,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "self-report in one click"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 716,
    y: 176,
    width: 168,
    height: 118,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 202,
    fontSize: 11.5,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "TESTER BUILDS"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 224,
    fontSize: 11,
    fill: "#4A5F56",
    textAnchor: "middle",
    fontFamily: "Consolas, monospace"
  }, "0.1.10  0.1.11  0.1.12"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 244,
    fontSize: 11,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "each with its own README"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 260,
    fontSize: 11,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "of what to try"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 176,
    width: 168,
    height: 118,
    rx: 10,
    fill: "#F7FAF8",
    stroke: "#16A34A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 202,
    fontSize: 11.5,
    fontWeight: 600,
    fill: "#16A34A",
    textAnchor: "middle"
  }, "CONFIRMED"), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 226,
    fontSize: 11,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "\"OBIAN works fine now\""), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 248,
    fontSize: 11,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "chrome, tabs, links, and"), /*#__PURE__*/React.createElement("text", {
    x: 1020,
    y: 264,
    fontSize: 11,
    fill: "#4A5F56",
    textAnchor: "middle"
  }, "find-in-page all respond"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 330,
    width: 1048,
    height: 86,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 358,
    fontSize: 12,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "STRUCTURED INTAKE, BEFORE AND AFTER"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 382,
    fontSize: 12,
    fill: "#4A5F56"
  }, "Public bug-report and showcase templates require OS and version up front, so the next report starts where this one"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 400,
    fontSize: 12,
    fill: "#4A5F56"
  }, "ended: with the facts the fix needs."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObianFig3FeedbackLoop);
export default __webpack_public_path__ + "static/media/obian-fig3-feedback-loop.c1dd705d967910fb11fc7721441b7c40.svg";
export { ForwardRef as ReactComponent };